const values = [
  {
    id: 'item-ac',
    className: 'bg-gray item-ac',
    value: 'AC',
  },
  {
    id: 'item-divd',
    className: 'bg-gray item-divd',
    value: '+/-',
  },
  {
    id: 'item-percent',
    className: 'bg-gray item-percent',
    value: '%',
  },
  {
    id: 'item-division',
    className: 'bg-orange item-division',
    value: '÷',
  },
  {
    id: 'item-seven',
    className: 'bg-gray item-seven',
    value: '7',
  },
  {
    id: 'item-eight',
    className: 'bg-gray item-eight',
    value: '8',
  },
  {
    id: 'item-nine',
    className: 'bg-gray item-nine',
    value: '9',
  },
  {
    id: 'item-x',
    className: 'bg-orange item-x',
    value: 'x',
  },
  {
    id: 'item-four',
    className: 'bg-gray item-four',
    value: '4',
  },
  {
    id: 'item-five',
    className: 'bg-gray item-five',
    value: '5',
  },
  {
    id: 'item-six',
    className: 'bg-gray item-six',
    value: '6',
  },
  {
    id: 'item-moins',
    className: 'bg-orange item-moins',
    value: '-',
  },
  {
    id: 'item-one',
    className: 'bg-gray item-one',
    value: '1',
  },
  {
    id: 'item-two',
    className: 'bg-gray item-two',
    value: '2',
  },
  {
    id: 'item-tree',
    className: 'bg-gray item-tree',
    value: '3',
  },
  {
    id: 'item-plus',
    className: 'bg-orange item-plus',
    value: '+',
  },
  {
    id: 'item-zero',
    className: 'bg-gray item-zero',
    value: '0',
  },
  {
    id: 'item-point',
    className: 'bg-gray item-point',
    value: '.',
  },
  {
    id: 'item-egal',
    className: 'bg-orange item-egal',
    value: '=',
  },
];

export default values;
